export default __webpack_public_path__ + "media/images/Shopping-Bag-3108c3bcd57ce29bf4153b5b5909774e.png";